import { ApiKeyStatus } from '../dto/api-key';
import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';

export const API_KEY_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: 'partner_name',
    label: 'apiKeys.fields.partnerName',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: 'partner_route',
    label: 'apiKeys.fields.partnerRoute',
    type: FilterType.text,
    value: '',
  },
  {
    fieldName: 'status',
    label: 'apiKeys.fields.status',
    type: FilterType.select,
    options: Object.values(ApiKeyStatus).map((value) => ({
      value,
      label: `apiKeys.status.${value}`,
      translate: true,
    })),
    value: '',
  },
];
